/**
 * NOS-125: Media topic tags. NOS-262: config over the shared taxonomy scaffold.
 */
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import {
  MediaTaxonomyPage,
  type TaxonomyColumn,
} from "@/components/dashboard/MediaTaxonomyPage"
import {
  useMediaTopics,
  type MediaTopicInput,
  type MediaTopicWithCount,
} from "@/hooks/useMediaTopics"
import { generateSlug } from "@/lib/slugUtils"

type TopicForm = { name: string; slug: string }

const columns: TaxonomyColumn<MediaTopicWithCount>[] = [
  { header: "Name", cell: (t) => t.name, cellClassName: "font-medium" },
  { header: "Slug", cell: (t) => t.slug, cellClassName: "text-muted-foreground" },
  { header: "Videos", cell: (t) => t.video_count },
]

export function MediaTopicsPage() {
  return (
    <MediaTaxonomyPage<MediaTopicWithCount, TopicForm, MediaTopicInput>
      useTaxonomy={useMediaTopics}
      title="Topics"
      tagline="Tag sermons for discovery."
      entity="Topic"
      columns={columns}
      emptyForm={{ name: "", slug: "" }}
      formFromRow={(t) => ({ name: t.name, slug: t.slug })}
      validate={(f) => (f.name.trim() ? null : "Name is required")}
      toPayload={(f) => ({ name: f.name, slug: f.slug })}
      deleteWarning="Topics assigned to videos cannot be deleted until removed from those videos."
      renderFields={(form, setForm, editing) => (
        <>
          <div>
            <Label>Name</Label>
            <Input
              value={form.name}
              onChange={(e) => {
                const name = e.target.value
                setForm((f) => ({
                  name,
                  // Slug follows the name until it has been edited by hand.
                  slug: !editing || f.slug === generateSlug(f.name) ? generateSlug(name) : f.slug,
                }))
              }}
            />
          </div>
          <div>
            <Label>Slug</Label>
            <Input
              value={form.slug}
              onChange={(e) => setForm((f) => ({ ...f, slug: e.target.value }))}
            />
          </div>
        </>
      )}
    />
  )
}
